import { useTranslation } from "react-i18next";

import { Link } from "@/components/_molecules/navigation-controls/link";
import { useDocumentTitle } from "@/hooks/use-document-title";

import PasswordForgottenForm from "../components/password-forgotten-form";

import AuthPageLayout from "./auth-page.layout";

export function PasswordForgotPage() {
  const { t } = useTranslation("auth");
  useDocumentTitle(t("passwordForgot.title"));

  return (
    <AuthPageLayout>
      <div className="z-10 w-full max-w-md overflow-hidden rounded-md shadow-xl">
        <div className="flex flex-col items-center justify-center space-y-3 px-4 py-6 pt-8 text-center sm:px-16">
          <h3 className="text-xl font-semibold">{t("passwordForgot.title")}</h3>
          <p className="text-sm ">
            {t("passwordForgot.description")}
          </p>
        </div>

        <PasswordForgottenForm />

        <p className="mb-8 text-center text-sm">
          {t("login.rememberCredentials")}{" "}
          <Link to="/login" className="font-semibold">
            {t("login.signIn")}
          </Link>{" "}
        </p>
      </div>
    </AuthPageLayout>
  );
}
